import styled from 'styled-components';
import { pxToRem } from '~/utils';

export const Content = styled.div`
  position: absolute;
  bottom: ${pxToRem(10)};
  right: ${pxToRem(10)};
`;
